import { Container, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import HowPodWorkMenuBox from './HowPodWorkMenuBox';
import HowItWorkImg1 from 'assets/images/HowItWorkImg1.png';
import HowItWorkImg2 from 'assets/images/HowItWorkImg2.png';
import HowItWorkImg3 from 'assets/images/HowItWorkImg3.png';
import HowItWorkImg4 from 'assets/images/HowItWorkImg4.png';
import HowItWorkImg5 from 'assets/images/HowItWorkImg5.png';
import HowItWorkImg6 from 'assets/images/HowItWorkImg6.png';
import HowItWorkImg7 from 'assets/images/HowItWorkImg7.png';
import HowItWorkImg8 from 'assets/images/HowItWorkImg8.png';

const useStyles = makeStyles((theme) => ({
  FlowChartMenuBoxsBg: {
    display: 'block',
    padding: '30px 0px 95px',
    backgroundColor: '#04B078',
  },

  box: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: '50px',
    '& ul': {
      width: '33.33%',
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        margin: 0,
      },
      listStyleType: 'none',
      '& li': {
        textAlign: 'center',
        marginBottom: '60px',
      },
    },
  },

  middleSectionDownMd: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column-reverse',
    },
  },
}));

export function StartupFlowChartMenuBoxs({ getValueOfId }) {
  const classes = useStyles();
  const handleId = (value) => {
    getValueOfId(value);
    console.log('value', value);
  };

  return (
    <div className={classes.FlowChartMenuBoxsBg}>
      <Container>
        <Grid item xs={12}>
          <div className={classes.box}>
            <ul>
              <li onClick={() => handleId('first-step')}>
                <HowPodWorkMenuBox
                  number="1"
                  content1="Join POD,"
                  content2="it's free"
                  img={HowItWorkImg1}
                />
              </li>
              <li onClick={() => handleId('second-step')}>
                <HowPodWorkMenuBox
                  number="2"
                  content1="Submit campaign"
                  // content2="assessment"
                  img={HowItWorkImg2}
                />
              </li>
              <li onClick={() => handleId('third-step')}>
                <HowPodWorkMenuBox
                  number="3"
                  content1="Screening and"
                  content2="due diligence"
                  className="HowPodWorkBoxBefore"
                  img={HowItWorkImg3}
                />
              </li>
            </ul>
            <ul className={classes.middleSectionDownMd}>
              <li onClick={() => handleId('six-step')}>
                <HowPodWorkMenuBox
                  number="6"
                  content1="Campaign"
                  content2="closed"
                  className="HowPodWorkBoxBefore"
                  img={HowItWorkImg4}
                />
              </li>
              <li onClick={() => handleId('five-step')}>
                <HowPodWorkMenuBox
                  number="5"
                  content1="Funding goal"
                  content2="reached"
                  className="HowPodWorkBoxup"
                  img={HowItWorkImg5}
                />
              </li>
              <li onClick={() => handleId('forth-step')}>
                <HowPodWorkMenuBox
                  number="4"
                  content1="Launch"
                  content2="campaign"
                  className="HowPodWorkBoxup"
                  img={HowItWorkImg6}
                />
              </li>
            </ul>
            <ul>
              <li onClick={() => handleId('seven-step')}>
                <HowPodWorkMenuBox
                  number="7"
                  content1="Receive"
                  content2="funds"
                  className="HowPodWorkBox"
                  img={HowItWorkImg7}
                />
              </li>
              <li onClick={() => handleId('eight-step')}>
                <HowPodWorkMenuBox
                  number="8"
                  content1="Issue"
                  content2="Share Certificate"
                  // content3="become a"
                  // content4="Shareholder!"
                  className="HowPodWorkBoxNoLine"
                  img={HowItWorkImg8}
                />
              </li>
            </ul>
          </div>
        </Grid>
      </Container>
    </div>
  );
}

export default function FlowChartMenuBoxs({ getValueOfId }) {
  const classes = useStyles();
  const handleId = (value) => {
    getValueOfId(value);
    console.log('value', value);
  };

  return (
    <div className={classes.FlowChartMenuBoxsBg}>
      <Container>
        <Grid item xs={12}>
          <div className={classes.box}>
            <ul>
              <li onClick={() => handleId('first-step')}>
                <HowPodWorkMenuBox
                  number="1"
                  content1="Join POD,"
                  content2="it's free"
                  img={HowItWorkImg1}
                />
              </li>
              <li onClick={() => handleId('second-step')}>
                <HowPodWorkMenuBox
                  number="2"
                  content1="Ace the"
                  content2="assessment"
                  img={HowItWorkImg3}
                />
              </li>
              <li onClick={() => handleId('third-step')}>
                <HowPodWorkMenuBox
                  number="3"
                  content1="Create"
                  content2="investor profile"
                  className="HowPodWorkBoxBefore"
                  img={HowItWorkImg2}
                />
              </li>
            </ul>
            <ul className={classes.middleSectionDownMd}>
              <li onClick={() => handleId('six-step')}>
                <HowPodWorkMenuBox
                  number="6"
                  content1="Receive"
                  content2="acknowledgement"
                  className="HowPodWorkBoxBefore"
                  img={HowItWorkImg4}
                />
              </li>
              <li onClick={() => handleId('five-step')}>
                <HowPodWorkMenuBox
                  number="5"
                  content1="Invest in a"
                  content2="startup you like"
                  className="HowPodWorkBoxup"
                  img={HowItWorkImg5}
                />
              </li>
              <li onClick={() => handleId('forth-step')}>
                <HowPodWorkMenuBox
                  number="4"
                  content1="Discover"
                  content2="startups"
                  className="HowPodWorkBoxup"
                  img={HowItWorkImg6}
                />
              </li>
            </ul>
            <ul>
              <li onClick={() => handleId('seven-step')}>
                <HowPodWorkMenuBox
                  number="7"
                  content1="Startup funding"
                  content2="goal reached"
                  className="HowPodWorkBox"
                  img={HowItWorkImg7}
                />
              </li>
              <li onClick={() => handleId('eight-step')}>
                <HowPodWorkMenuBox
                  number="8"
                  content1="Receive Share"
                  content2="Certificate and"
                  content3="become a"
                  content4="Shareholder!"
                  className="HowPodWorkBoxNoLine"
                  img={HowItWorkImg8}
                />
              </li>
            </ul>
          </div>
        </Grid>
      </Container>
    </div>
  );
}
